module.exports = __webpack_public_path__ + "img/nbus.0b7a3722.png";